import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ModalService } from '@purespectrum1/ui/modal';
import { ServiceAccountModalComponent } from '../../layout/header/user-menu/service-account-modal/service-account-modal.component';
import { AuthService } from '../../auth/auth.service';
import { AuthState } from '@purespectrum1/ui/marketplace/shared/interfaces/auth.interface';
import { MultiBuyerModalComponent } from '../multi-buyer-modal/multi-buyer-modal.component';

@Component({
  selector: 'ps-recontact-survey',
  templateUrl: './recontact-survey.component.html',
  styleUrls: ['./recontact-survey.component.css'],
})
export class RecontactSurveyComponent implements OnInit, OnDestroy {
  public auth: AuthState = this._auth.getMarketplaceAuth;
  private readonly _subscriptions = new Subscription();
  constructor(
    private _router: Router,
    private _modal: ModalService,
    private _auth: AuthService
  ) {}

  ngOnInit(): void {
    this._onHandleAuthSub();
    this._onHandleMultiBuyerModalSelectionSub();
  }

  goToDashboard() {
    this._router.navigateByUrl('/dashboard');
  }

  selectBuyer(open: boolean) {
    if (open) {
      this._modal.open(ServiceAccountModalComponent, {});
    }
  }

  private _onHandleAuthSub() {
    this._subscriptions.add(
      this._auth.loggedInAsServiceBuyer$.subscribe(() => {
        this.auth = this._auth.getMarketplaceAuth;
      })
    );
  }

  private _onHandleMultiBuyerModalSelectionSub() {
    this._subscriptions.add(
      this._auth.loggedInAsMultiBuyer$
        .pipe(distinctUntilChanged())
        .subscribe((isMultiBuyerLogged) => {
          const hasRegionalEntitySelected: boolean =
            this._auth.selectedMultiBuyerCompany !== undefined;

          if (isMultiBuyerLogged && !hasRegionalEntitySelected) {
            this.openMultiBuyerSelection();
          }
        })
    );
  }

  public openMultiBuyerSelection() {
    const cmpId =
      this.auth.selectedMultiBuyerCompany?.parentCompany ?? this.auth.user?.cmp;
    this._modal.open(MultiBuyerModalComponent, {
      data: { cmpId: cmpId },
    });
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
}
